export const mockAutofillResponse: string[][] = [
  ['1', '2'],
  ['3', '4'],
  ['5', '6']
]
